import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { IMenuItem, IMenuItemOption, IStoreMenuCategoryItem, IMenuItemOptionCategory, IStoreMenuItemOptionCategory, IStoreMenuItemOption, StoreService, IItemDetailCombination, IStore } from '../../services/store.service';
import { AnimationController, ModalController } from '@ionic/angular';
import { retryWhen, finalize, first } from 'rxjs/operators';
import { ImageService } from 'src/app/shared/services/image.service';
import { ActivatedRoute } from '@angular/router';
import { StmtModifier } from '@angular/compiler';
import { ItemService } from '../../services/item.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { IOrder, IOrderItem } from '../../services/order.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-item-option',
    templateUrl: './item-option.component.html',
    styleUrls: ['./item-option.component.scss'],
    standalone: false
})
export class ItemOptionComponent implements OnInit {
  @Input() item: IStoreMenuCategoryItem;
  @Input() orderItem: IOrderItem;
  @Input() optionIndex: number;
  @Input() back: boolean;
  @Input() store: IStore;
  @Input() order: IOrder;
  storeId: string;
  categorySelectedId: string = null;
  chainItemSelectedId: string = null;

  @ViewChild('chainItemOptionCategories', { static: false }) chainItemOptionCategories!: ElementRef;

  title: string = 'Options';
  options: IMenuItemOption[] = [];

  get total(): number {
    let total = this.orderItem.price;
    /*for (let option of this.orderItem.options) {
      if(this.item.item.itemOptionCategories[this.optionIndex].overrideDefaultPrice) {
        total = option.price;
        option._overide = true;
      } else {
        total += option.price
      }
    }   */

    for (let i = 0; i < this.options.length; i++) {
      let option = this.options[i];
      let qty = option.quantity == null ? 1 : option.quantity;      //Just making sure that if the quantity is null, it does not break the calculation
      total += qty * option.price;
    }
  
    return total;
  }

  constructor(
    public route: ActivatedRoute,
    private modalCtrl: ModalController,
    private animationCtrl: AnimationController,
    //public translateService: TranslateService,
    public translationService: TranslationService,
    private storeService: StoreService,
    private imageService: ImageService,
    private itemService: ItemService,
    public settingService: SettingService) {
  }

  ngOnInit() {
    this.setOptionImages(this.item.item.itemOptionCategories);
    this.item.item.itemOptionCategories[this.optionIndex].options.forEach(option => {
      if (!isNaN(option.option.quantity)) {
          this.options.push(option.option);
          if(this.item.item.itemOptionCategories[this.optionIndex].chainItem && option.option.quantity > 0){
            this.chainItemSelectedId = option.itemId;
            this.item.item.itemOptionCategories[this.optionIndex].options.forEach(chainOption => {
              chainOption.chainItemOptionCategories.forEach(chainOptionCategory => {
                chainOptionCategory.options.forEach(chainOptionCategoryOption => {
                  if(chainOptionCategoryOption.option.quantity > 0){
                    this.options.push(chainOptionCategoryOption.option);
                  }
                })
              })
            });
          }
      }    
    });
  } 
  


  optionSelected(option: IMenuItemOption, category: IStoreMenuItemOptionCategory, submit: boolean = false, isChainItemOption: boolean = false) {
     //Adding the check for a third party inventory in stock information when it is enabled for the store
    //console.log(category);

    if(this.store){
      if (this.store.useThirdPartyInventory) {
        if (option != null && option.externalPOSId != null) {
            //only do the check if the item has an id from the POS
            //check how many time we already have that item in the card, we must already check for the total of quantities we need
            let count:number = 1;
  
            for (let i = 0; i < this.order.orderItems.length; i++) {
              for (let j = 0; j < this.order.orderItems[i].options.length; j++) {
                if ((option.id != null && this.order.orderItems[i].options[j].optionId == option.id) ||  (option.itemId != null && this.order.orderItems[i].options[j].itemId == option.itemId)) {
                  count++;
                }
              }           
            }

            this.itemService.validateThirdPartyQuantities(this.store.id, option.externalPOSId, count).subscribe(success => {
              if (!success) {
                  option.isActive = false;
                 // this.notAvailable(this.translateService.instant('Item.InventoryWarningHeader'), this.translateService.instant('Item.InventoryWarningContent'))
                 console.log("not enough quantities");
                  return;
                 
              } else {
                this.proceedToOptionSelect(option, category, submit, isChainItemOption);
              }
  
            });
        } else {
          this.proceedToOptionSelect(option, category, submit,isChainItemOption);
        }
      } else {
        this.proceedToOptionSelect(option, category, submit, isChainItemOption);
      }
    } else {
      this.proceedToOptionSelect(option, category, submit, isChainItemOption);
    }
    
  
    
  }

  async proceedToOptionSelect(option: IMenuItemOption, category: IStoreMenuItemOptionCategory, submit: boolean = false, isChainItemOption: boolean ) {
    if(option && option.itemDetailCombination)
    this.modalCtrl.dismiss({
      cancel: false,
      option: this.options,
      hidePrice: category ? category.overrideDefaultPrice : false,
      chainItemId: this.chainItemSelectedId,
      optionIndex: this.optionIndex,
      categoryId: category.id,
      index: localStorage['editKey'] ? localStorage['editKey'] : null
  });

  if(!submit && category.chainItem && option.itemId != null){
    for(let i = 0; i < this.item.item.itemOptionCategories[this.optionIndex].options.length; i++) {
      if (this.item.item.itemOptionCategories[this.optionIndex].options[i].itemId != option.itemId &&
        this.item.item.itemOptionCategories[this.optionIndex].options[i].option._selected) {
         
          this.item.item.itemOptionCategories[this.optionIndex].options[i].option._selected = false;
          
        }
    }

    option._selected = true;
    option.quantity = 1;   
    this.chainItemSelectedId = option.itemId;

    if(!this.options.some(o => ((option.id != null && o.id == option.id) || o.itemId == option.itemId ))){
      this.options.push(option);
    }

    setTimeout(() => {
      this.chainItemOptionCategories.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
    return;
  }

  if (option != null && !submit && isChainItemOption) {
    if(this.options.some(o => ((option.id != null && o.id == option.id) || o.itemId == option.itemId )) && option.quantity > 0){
      this.addOption(option, category);
    } else {
      option._selected = true;
      option.quantity = 1;
      option._optionCategoryId = category.id;  
      option._chainItemId = this.chainItemSelectedId; 
      this.options.push(option);
    }
    return;
  }

  //When clicking on a categoryId
  if (!submit && option.categoryId != null && option.categoryItems != null/*&& this.categorySelectedId == null*/) {
    //Check if another category was already clicked to reset the others

 

    for(let i = 0; i < this.item.item.itemOptionCategories[this.optionIndex].options.length; i++) {
      if (this.item.item.itemOptionCategories[this.optionIndex].options[i].option.categoryId != option.categoryId &&
        this.item.item.itemOptionCategories[this.optionIndex].options[i].option._selected) {
         
          this.item.item.itemOptionCategories[this.optionIndex].options[i].option._selected = false;
          
        }
    }

    option._selected = true;
    this.categorySelectedId = option.categoryId;
    
    return;
  } else if(!submit && option.categoryId != null && this.categorySelectedId == null) {

  } 

 if (category.autoSkip &&!submit ) {
   if (category && category.isMultiple && !submit) {
     let optionIndex=-1;
     let totalQty=1
     if (option != null) {
     this.options.forEach((options, index) => {
  
     if ((option.id != null && options.id == option.id) ||  (option.itemId != null && options.itemId == option.itemId)) {

     optionIndex = index;
   
  }

      totalQty += options.quantity != null ? options.quantity : 0;
});
} 

   if (category.multipleLimit <= totalQty &&!submit) {
      this.modalCtrl.dismiss({
      cancel: false,
      option: this.options,
      hidePrice: category ? category.overrideDefaultPrice : false,
      chainItemId: this.chainItemSelectedId,
      optionIndex: this.optionIndex,
      categoryId: category.id,
      index: localStorage['editKey'] ? localStorage['editKey'] : null
});
}

}
}

  //Now implementing the +/- for options, so another function is taking care of adding/removing to quantity
  if (category && category.isMultiple && !submit) {
  
    this.addOption(option, category);
    return;
  }

  //First check if the option is not already in the list, if so, remove it
 // let found = false;
  if (option != null) {
    for (let i = this.options.length - 1; i >= 0; i--) {
      if (this.options[i].id == option.id ||  (this.options[i].itemId == option.itemId)) {
          option._selected = false;
          option.quantity -= option.quantity > 0 ? 1 : 0;
          this.options.splice(i, 1);
      //  found = true;
      //  return;
      }
    }
    /*this.options.forEach((options, index) => {
      if ((option.id != null && options.id == option.id) ||  (option.itemId != null && options.itemId == option.itemId)) {        
        option._selected = false;
   
        option.quantity -= option.quantity > 0 ? 1 : 0;
        this.options.splice(index, 1);
        found = true;
        return;
      }
    });*/
  }
 
   //Check if the config is not multiple, unselect the other selected options of there are
   if (category && !category.isMultiple && !submit) {
    category.options.forEach(t => {
        if (t.option._selected) {
          this.options.forEach((selectedOption, index) => {
            if (selectedOption.id == t.optionId || selectedOption.id == t.itemId) {
              this.options.splice(index, 1);
              return;
            }
          });
        }
 
        t.option._selected = false;
      });
    }

  //Check if a limited amount only can be selected
  if (!submit && (category && category.isMultiple && category.multipleLimit == this.options.length) /*||
    found*/) {
 
    return;
    
  }

 

  if (option != null && !submit) {
    option._selected = true;
    option.quantity = 1;
    this.options.push(option);     
  }
 
  if (category && category.isMultiple && !submit) {
    return;
  } else {
    console.log("save options");
    localStorage.setItem('SaveOrder', JSON.stringify(this.orderItem));

    console.log(this.options);
    console.log(this.orderItem);

    console.log(this.orderItem.price)

    //this.orderItem.price


    //localStorage['storeId']=
    this.modalCtrl.dismiss({
      cancel: false,
      option: this.options,
      hidePrice: category ? category.overrideDefaultPrice : false,
      chainItemId: this.chainItemSelectedId,
      optionIndex: this.optionIndex,
      categoryId: category.id,
      index: localStorage['editKey'] ? localStorage['editKey'] : null
    });

  }

  }

  //addOption is working fine
  addOption(option: IMenuItemOption, category: IStoreMenuItemOptionCategory) {
    //First check if the option is not already in the list, if so, remove it
    this.back = false; //back has to be false because if left true then this.options becomes empty in optionSelected function
    let optionIndex =- 1;
    let totalQty = 0;
    if (option != null) {
      this.options.forEach((options, index) => {
        if ((option.id != null && options.id == option.id) ||  (option.itemId != null && options.itemId == option.itemId)) {
         // this.options.splice(index, 1);
          optionIndex = index;
         
        }
        if(option._optionCategoryId != null){
          if(options._optionCategoryId == category.id){
            totalQty += options.quantity != null ? options.quantity : 0;
          }
        } else {
          //Lets calculate if we reached the max limit of choice by checking the quantity of all selected options
          totalQty += options.quantity != null ? options.quantity : 0;
        }
      });
    }   
    if (!(totalQty < category.multipleLimit) && !category.isMultipleUnlimited) {
      return;
    }

    if (optionIndex != -1) {
      if (this.options[optionIndex].quantity + 1 <= category.multipleLimit || category.isMultipleUnlimited) {
        this.options[optionIndex].quantity += 1;
        option._selected = true;
      }       
     /*
     config needs to be developed on seemy store
     this.optionSelected(null, category, true)
    */
    } else {
     
      option.quantity = 1; 
      option._selected = true;
      this.options.push(option);
    }    
  }


  //next step removeOption
  removeOption(option: IMenuItemOption, event: Event) {

    //First check if the option is not already in the list, if so, remove it
    let optionIndex = -1;
    if (option != null) {
      this.options.forEach((options, index) => {
        if ((options.id != null && options.id == option.id) || (options.itemId != null && options.itemId == option.itemId)) {
          optionIndex = index;

          return;
        }
      });
    }

    //this required change

    if (optionIndex != -1) {

      if((this.options[optionIndex].quantity - 1) != -1) {
        this.options[optionIndex].quantity -= 1;
     

        if (this.options[optionIndex].quantity <= 0) {


          this.options.splice(optionIndex, 1);
        

          option._selected = false;
        }
      }
      
    }
    event.stopPropagation();
  }

  getOptionsQty(optionCategoryId: string = null) {
    if(this.chainItemSelectedId && optionCategoryId == null){
      return 1;
    }
    let qty:number = 0;
    this.options.forEach(option => {
      if(option._optionCategoryId == optionCategoryId){
        qty += null != option.quantity ? option.quantity : 0;
      }
      
    });

    return qty;
  }

  cancel() {
    this.item.item.itemOptionCategories[this.optionIndex].options.map(option=>{
      option.option.quantity=0;
    })
    this.modalCtrl.dismiss({
      cancel: true
    });
  }
 
  disabledNextBtn() {
    let optionCategory = this.item.item.itemOptionCategories[this.optionIndex];
    if (!optionCategory.isOptionnal) {
      //If the category is not optionnal, must check if we reached the limit amount to let the user continue with his order
      if ((optionCategory.multipleLimit != null && this.getOptionsQty() == optionCategory.multipleLimit)
      || (optionCategory.isMultipleUnlimited && this.getOptionsQty() > 0)
      || (optionCategory.chainItem && this.getOptionsQty() > 0)) {
      // let i=0;
      // i++

  
        return false;
      }
      return true;
    }
 
    return false;   
  }

  /*disabledNextBtn(chainItemOptionCategory: IStoreMenuItemOptionCategory = null) {
    let disableBtn = false;
    let optionCategory: IStoreMenuItemOptionCategory;
    optionCategory = chainItemOptionCategory != null ? chainItemOptionCategory : this.item.item.itemOptionCategories[this.optionIndex];
    let optionCategoryId = chainItemOptionCategory != null ? chainItemOptionCategory.id : null;

    if(optionCategory.chainItem && chainItemOptionCategory == null){
      optionCategory.options.forEach(option => {
        if(this.chainItemSelectedId == option.itemId){
          option.chainItemOptionCategories.forEach(category => {
            if(this.disabledNextBtn(category)){
              disableBtn = true;
            }
          });
        }
      });
      return disableBtn;
    }
    
    if (!optionCategory.isOptionnal) {
      //If the category is not optionnal, must check if we reached the limit amount to let the user continue with his order
      if ((optionCategory.multipleLimit != null && this.getOptionsQty(optionCategoryId) == optionCategory.multipleLimit)
      || (optionCategory.isMultipleUnlimited && this.getOptionsQty(optionCategoryId) > 0)
      || (optionCategory.chainItem && this.getOptionsQty(optionCategoryId) > 0)) {
      // let i=0;
      // i++
        return false;
      }

      if(chainItemOptionCategory != null){
        if(optionCategory.isMultiple == true){
          return false;
        } else {
          return true;
        }
      }
      return true;
    }
    return false;   
  }*/

  backOption(index: number) {
    if (index > this.optionIndex) {
     
      return;
    }
    //If it is not a multiple choice, reset the _selected flag
    this.modalCtrl.dismiss({
      cancel: false,
      option: this.options,
      optionIndex: index,
      back: true,
      index:  localStorage['editKey'] ? localStorage['editKey'] : null
    });
   // this.optionIndex = index;
  }

  backSelectedCount(optionCategoryId: string = null) {
    if(this.chainItemSelectedId && optionCategoryId == null){
      return 1;
    }
    let count = 0;
    this.item.item.itemOptionCategories[this.optionIndex].options.forEach(option => {
      if(this.item.item.itemOptionCategories[this.optionIndex].chainItem){
        let chainOptionCategory = option.chainItemOptionCategories.find(t => t.id == optionCategoryId);
        if(chainOptionCategory){
          if(chainOptionCategory.id == optionCategoryId){
            chainOptionCategory.options.forEach(chainOptionCategoryOption => {
              count += !isNaN(chainOptionCategoryOption.option.quantity) ? chainOptionCategoryOption.option.quantity : 0;
            });
          }
        }
      } else {
        count += !isNaN(option.option.quantity) ? option.option.quantity : 0;
      }
    });

    return count;
  }
  
  setOptionImages(optionCategories: IStoreMenuItemOptionCategory[]) {
    for (let category of optionCategories) {
      for (let option of category.options) {
        this.fetchItemImage(option);
      }
    }
  }

  showOptionsInline(optionCategory: IStoreMenuItemOptionCategory) {  
    return optionCategory.isHorizontalDisplay;
  }

  getSelectedCategoryItems() {
    let items = [];
    for (let i = 0; i < this.item.item.itemOptionCategories[this.optionIndex].options.length; i++) {
      if (this.categorySelectedId == this.item.item.itemOptionCategories[this.optionIndex].options[i].categoryId) {
        items = this.item.item.itemOptionCategories[this.optionIndex].options[i].option.categoryItems;
      }      
    }
 
    return items;
  }

  getSelectedChainItemOptionCategories(){
    let chainItemOptionCategories = [];
    for (let i = 0; i < this.item.item.itemOptionCategories[this.optionIndex].options.length; i++) {
      if (this.chainItemSelectedId == this.item.item.itemOptionCategories[this.optionIndex].options[i].itemId) {
        chainItemOptionCategories = this.item.item.itemOptionCategories[this.optionIndex].options[i].chainItemOptionCategories;
      }      
    }
 
    return chainItemOptionCategories;
  }

  getItemDetailCombinationModifierIndex(option: IStoreMenuItemOption): number{
    if(option.option.itemDetailCombination == null){
      return -1;
    }
    for(let i = 0; i < option.option.itemDetailCombination.length; i++){
      if(option.option.itemDetailCombination[i].modifier){
        return i;
      }
    }
    return -1;
  }

  private fetchItemImage(option: IStoreMenuItemOption) {
    if (option.option.imageShortName != null && option.option.imageShortName != "" && option.option._image == null) {
      this.storeService.getItemImage(option.option.imageShortName).subscribe(data => {
        this.imageService.createImageFromBlob(data)
        .pipe(finalize(() => {
           
        }))
        .subscribe((buffer) => {
          option.option._image = buffer;
        });       
      }, error => {
      });
    }
  }
}
